import ProductDescription from "@features/product/product-description/product-description";
import ProductLocation from "@features/product/product-location/product-location";
import ProductProps from "@features/product/product-props/product-props";
import ProductScreen from "@features/product/product-screen/product-screen";

export { ProductDescription, ProductLocation, ProductProps, ProductScreen };

export { Gallery } from "./gallery/gallery";
export { SimilarProducts } from "./ui/similar-products/similar-products";